import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useOrganizationFeatureUIContext } from "./OrganizationFeatureUIContext";
import OrganizationFeatureTable from "./organization-feature-table/OrganizationFeatureTable";
import { OrganizationFeatureFilter } from "./organization-feature-table/organization-feature-filter/OrganizationFeatureFilter";
import { RoleChecker } from "../../../../RoleChecker";

export const OrganizationFeatureCard = () => {
  const organizationFeatureUIContext = useOrganizationFeatureUIContext();
  const organizationFeatureUIProps = useMemo(() => {
    return {
      openEditOrganizationFeaturePage:
        organizationFeatureUIContext.openEditOrganizationFeaturePage
    };
  }, [organizationFeatureUIContext]);

  const allowEdit = RoleChecker("Edit", "organization_feature");

  return (
    <Card>
      <CardHeader title="Daftar Fitur Lembaga">
        <CardHeaderToolbar></CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/* <OrganizationFeatureFilter /> */}
        <OrganizationFeatureTable allowEdit={allowEdit} />
      </CardBody>
    </Card>
  );
};
